/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_VanInputs */

const en_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van`)
};

const es_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Furgoneta`)
};

const fr_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fourgonnette`)
};

const de_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transporter`)
};

const ja_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バン`)
};

const zh_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`厢式货车`)
};

const ar_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شاحنة صغيرة (فان)`)
};

const id_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van`)
};

const it_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Furgone`)
};

const ru_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фургон/Микроавтобус`)
};

const pt_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van`)
};

const ko_val_van = /** @type {(inputs: Val_VanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승합차(밴)`)
};

/**
* | output |
* | --- |
* | "Van" |
*
* @param {Val_VanInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_van = /** @type {((inputs?: Val_VanInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_VanInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_van(inputs)
	if (locale === "es") return es_val_van(inputs)
	if (locale === "fr") return fr_val_van(inputs)
	if (locale === "de") return de_val_van(inputs)
	if (locale === "ja") return ja_val_van(inputs)
	if (locale === "zh") return zh_val_van(inputs)
	if (locale === "ar") return ar_val_van(inputs)
	if (locale === "id") return id_val_van(inputs)
	if (locale === "it") return it_val_van(inputs)
	if (locale === "ru") return ru_val_van(inputs)
	if (locale === "pt") return pt_val_van(inputs)
	return ko_val_van(inputs)
});